var BUTTON_SIZES = ["small", "medium", "large"];
var DEFAULT_BUTTON_SIZE = BUTTON_SIZES[1];
var DEFAULT_BUTTON_VARIANT = "primary";
var DEFAULT_LINK_SIZE = "medium";
var DEFAULT_LINK_WEIGHT = "regular";
var SHORTHAND_CSS_RULE_MAPPING = {
  c: "color",
  d: "display",
  f: "flex",
  o: "order",
  pos: "position",
  m: "margin",
  mt: "marginTop",
  mb: "marginBottom",
  ml: "marginLeft",
  mr: "marginRight",
  mx: "marginX",
  marginX: "marginX",
  marginY: "marginY",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pb: "paddingBottom",
  pr: "paddingRight",
  pl: "paddingLeft",
  px: "paddingX",
  paddingX: "paddingX",
  py: "paddingY",
  paddingY: "paddingY",
  w: "width",
  maxw: "maxWidth",
  minw: "minWidth",
  h: "height",
  minh: "minHeight",
  maxh: "maxHeight",
  bgc: "backgroundColor",
  bgi: "backgroundImage",
  bg: "background",
  b: "border",
  bl: "borderLeft",
  br: "borderRight",
  bt: "borderTop",
  bb: "borderBottom",
  brad: "borderRadius",
  bradtl: "borderTopLeftRadius",
  bradtr: "borderTopRightRadius",
  bradbl: "borderBottomLeftRadius",
  bradbr: "borderBottomRightRadius"
};
var DEFAULT_AWS_IMAGE_RESIZER_URL = "https://image-resizer-cache.dev.immutable.com";
var DEFAULT_LOADING_IMG_ATTR = "lazy";
var LOADING_OVERLAY_SIZES = ["small", "medium"];
var DEFAULT_LOADING_OVERLAY_SIZE = LOADING_OVERLAY_SIZES[1];
var IMAGE_SIZE_VARIANTS = ["small", "medium", "large", "xLarge"];
var DEFAULT_IMAGE_SIZE_VARIANT = IMAGE_SIZE_VARIANTS[1];
var DEFAULT_IMAGE_SIZE = 256;
var TOOLTIP_SIZES = ["small", "medium", "large"];
var DEFAULT_TOOLTIP_SIZE = TOOLTIP_SIZES[1];
var DRAWER_POSITIONS = ["bottom", "right", "left"];
var DRAWER_SIZES = ["quarter", "half", "threeQuarter", "full", "edge"];
var DEFAULT_DRAWER_SIZE = DRAWER_SIZES[2];
var DEFAULT_DRAWER_POSITION = DRAWER_POSITIONS[0];
var TEXT_AREA_SIZES = ["medium", "large"];
var DEFAULT_TEXT_AREA_SIZE = TEXT_AREA_SIZES[0];
var DEFAULT_TEXT_AREA_ALIGN = "left";
var MENU_ITEM_SIZES = ["xSmall", "small", "medium"];
var DEFAULT_MENU_ITEM_SIZE = MENU_ITEM_SIZES[2];
var DEFAULT_TEXT_INPUT_SIZE = "medium";
var DEFAULT_TEXT_INPUT_ALIGN = "left";
var TEXT_INPUT_SIZES = ["medium", "large"];
var INPUT_MIN_WIDTH = "216px";
var DEFAULT_SELECT_SIZE = DEFAULT_TEXT_INPUT_SIZE;
var SELECT_SIZES = TEXT_INPUT_SIZES;
var CHIP_SIZES = [].concat(TEXT_INPUT_SIZES);
var DEFAULT_CHIP_SIZE = CHIP_SIZES[0];
var TOOLBAR_SIZES = ["small", "medium"];
var DEFAULT_TOOLBAR_SIZE = TOOLBAR_SIZES[1];
var TIMELINE_VARIANTS = ["vertical/before", "vertical/split", "vertical/after", "horizontal/left/before", "horizontal/left/after", "horizontal/center/before", "horizontal/center/after"
// @TODO: these modes will require additional work. :(
// 'horizontal/left/split',
// 'horizontal/center/split',
];
var DEFAULT_TIMELINE_VARIANT = TIMELINE_VARIANTS[2];
var DUO_CON_OUTER_SHAPES = ["circle", "hexagon", "triangle"];
var PROGRESS_BAR_VARIANTS = ["determinate", "indeterminate"];
var PROGRESS_BAR_SIZES = ["small", "medium"];
var DEFAULT_PROGRESS_BAR_SIZE = PROGRESS_BAR_SIZES[1];
var PROGRESS_BAR_COLOR_VARIANTS = ["guidance", "brand", "inverted", "gradient"];
var DEFAULT_PROGRESS_BAR_COLOR_VARIANT = PROGRESS_BAR_COLOR_VARIANTS[0];
var CARD_HERO_SIZES = ["small", "medium", "large"];
var DEFAULT_CARD_HERO_SIZE = CARD_HERO_SIZES[0];
var TABLE_SPACING_SIZES = ["xxSmall", "xSmall", "small", "medium", "xLarge", "xxLarge"];
var DEFAULT_TABLE_SPACING = "medium";
var DUMMY_RASTER_IMAGE_URL = "https://biome.immutable.com/hosted-assets/demo-images/frog.png";
var DUMMY_RASTER_IMAGE_2_URL = "https://biome.immutable.com/hosted-assets/demo-images/tree-dude.jpg";
var DUMMY_RASTER_IMAGE_3_URL = "https://biome.immutable.com/hosted-assets/demo-images/pastelle-gradients.png";
var DUMMY_VECTOR_IMAGE_URL = "https://biome.immutable.com/hosted-assets/currency-icons/currency--eth.svg";
var IMX_TOKEN_IMAGE_URL = "https://biome.immutable.com/hosted-assets/currency-icons/currency--imx.svg";
var GODS_TOKEN_IMAGE_URL = "https://biome.immutable.com/hosted-assets/currency-icons/currency--gods.svg";
var ETH_TOKEN_IMAGE_URL = "https://biome.immutable.com/hosted-assets/currency-icons/currency--eth.svg";
var GOG_TOKEN_IMAGE_URL = "https://biome.immutable.com/hosted-assets/currency-icons/currency--gog.svg";
var ON_LIGHT_FALLBACK_TOKEN_IMAGE_URL = "https://biome.immutable.com/hosted-assets/images/defaultTokenImage--onLight.svg";
var ON_DARK_FALLBACK_TOKEN_IMAGE_URL = "https://biome.immutable.com/hosted-assets/images/defaultTokenImage--onDark.svg";
var DUMMY_RIVE_ANIMATION_URL = "https://cdn.rive.app/animations/vehicles.riv";
var DUMMY_HLS_VIDEO_URL = "https://biome.immutable.com/hosted-assets/video/Big_Buck_Bunny_HLS/bbb.m3u8";
var DUMMY_BAD_410_HLS_VIDEO_URL = "https://biome.immutable.com/hosted-assets/video/bad-hls-video.m3u8";
var DUMMY_SMALL_MP4_VIDEO_URL = "https://biome.immutable.com/hosted-assets/video/Big_Buck_Bunny_360_10s.mp4";
var DUMMY_SMALL_WEBM_VIDEO_URL = "https://biome.immutable.com/hosted-assets/video/Big_Buck_Bunny_360_10s.webm";
var DUMMY_LARGE_MP4_VIDEO_URL = "https://biome.immutable.com/hosted-assets/video/Big_Buck_Bunny-1080_30s.mp4";
var DUMMY_LARGE_WEBM_VIDEO_URL = "https://biome.immutable.com/hosted-assets/video/Big_Buck_Bunny-1080_30s.webm";
var RATING_SIZES = ["small", "medium", "large", "xLarge"];
var DEFAULT_RATING_SIZE = RATING_SIZES[1];

export { BUTTON_SIZES, CARD_HERO_SIZES, CHIP_SIZES, DEFAULT_AWS_IMAGE_RESIZER_URL, DEFAULT_BUTTON_SIZE, DEFAULT_BUTTON_VARIANT, DEFAULT_CARD_HERO_SIZE, DEFAULT_CHIP_SIZE, DEFAULT_DRAWER_POSITION, DEFAULT_DRAWER_SIZE, DEFAULT_IMAGE_SIZE, DEFAULT_IMAGE_SIZE_VARIANT, DEFAULT_LINK_SIZE, DEFAULT_LINK_WEIGHT, DEFAULT_LOADING_IMG_ATTR, DEFAULT_LOADING_OVERLAY_SIZE, DEFAULT_MENU_ITEM_SIZE, DEFAULT_PROGRESS_BAR_COLOR_VARIANT, DEFAULT_PROGRESS_BAR_SIZE, DEFAULT_RATING_SIZE, DEFAULT_SELECT_SIZE, DEFAULT_TABLE_SPACING, DEFAULT_TEXT_AREA_ALIGN, DEFAULT_TEXT_AREA_SIZE, DEFAULT_TEXT_INPUT_ALIGN, DEFAULT_TEXT_INPUT_SIZE, DEFAULT_TIMELINE_VARIANT, DEFAULT_TOOLBAR_SIZE, DEFAULT_TOOLTIP_SIZE, DRAWER_POSITIONS, DRAWER_SIZES, DUMMY_BAD_410_HLS_VIDEO_URL, DUMMY_HLS_VIDEO_URL, DUMMY_LARGE_MP4_VIDEO_URL, DUMMY_LARGE_WEBM_VIDEO_URL, DUMMY_RASTER_IMAGE_2_URL, DUMMY_RASTER_IMAGE_3_URL, DUMMY_RASTER_IMAGE_URL, DUMMY_RIVE_ANIMATION_URL, DUMMY_SMALL_MP4_VIDEO_URL, DUMMY_SMALL_WEBM_VIDEO_URL, DUMMY_VECTOR_IMAGE_URL, DUO_CON_OUTER_SHAPES, ETH_TOKEN_IMAGE_URL, GODS_TOKEN_IMAGE_URL, GOG_TOKEN_IMAGE_URL, IMAGE_SIZE_VARIANTS, IMX_TOKEN_IMAGE_URL, INPUT_MIN_WIDTH, LOADING_OVERLAY_SIZES, MENU_ITEM_SIZES, ON_DARK_FALLBACK_TOKEN_IMAGE_URL, ON_LIGHT_FALLBACK_TOKEN_IMAGE_URL, PROGRESS_BAR_COLOR_VARIANTS, PROGRESS_BAR_SIZES, PROGRESS_BAR_VARIANTS, RATING_SIZES, SELECT_SIZES, SHORTHAND_CSS_RULE_MAPPING, TABLE_SPACING_SIZES, TEXT_AREA_SIZES, TEXT_INPUT_SIZES, TIMELINE_VARIANTS, TOOLBAR_SIZES, TOOLTIP_SIZES };
//# sourceMappingURL=constants.js.map
